module.exports = __webpack_public_path__ + "static/media/14.48c79716.jpg";